import { DbRef, WaypointActionType, ProcedureStatus, WaypointActionStatusName, WaypointStatusName, SampleStatus, WaypointStatusFulfillmentOrder, WaypointType, SupplyInstructionOptions } from '@caresend/types';
import { isNullish, fetchWithRelationships, errorSuffix, objectFilter, nullishFilter, hasStatus, getValidatedFeedback, removeUndefinedValuesFromObj, arrayToObj, flattenArray, isMailInAction, timeZoneDateMatchesLocalDate, deduplicateArray, getLatestInListTimestamp } from '@caresend/utils';
import update from 'immutability-helper';
import 'firebase/auth';
import { getDraftWaypointDataRequest, getItineraryDrivingEstimateRequest, setWaypointActionStatusRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/firebaseConfig/init.js';
import { dbSet, dbUpdate, dbGroupSet } from '../../../database/firebaseConfig/methods.js';
import { getElementsFromIDs } from '../../../functions/array.js';
import { toastErrorAndReport, toastSuccess, toastError } from '../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import '@sentry/vue';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { hasMutation, customCommit, isPatientUser } from '../../helpers.js';
import { initExtendedModule } from '../helpers.js';
import { setDraftWaypointDataInStore } from '../../set/draftWaypoint.js';

/* eslint sort-keys: "error" */
const waypointState = {
    draftWaypoints: {},
    itineraries: {},
    nurseItineraries: [],
    sampleProcessingActions: {},
    waypointActions: {},
    waypoints: {},
};
const waypointMutations = {
    'waypoint/DELETE_ITINERARY': (state, id) => {
        var _a;
        state.itineraries = update((_a = state.itineraries) !== null && _a !== void 0 ? _a : {}, {
            $unset: [id],
        });
    },
    'waypoint/DELETE_WAYPOINT': (state, id) => {
        var _a;
        state.waypoints = update((_a = state.waypoints) !== null && _a !== void 0 ? _a : {}, {
            $unset: [id],
        });
    },
    'waypoint/DELETE_WAYPOINT_ACTION': (state, id) => {
        var _a;
        state.waypointActions = update((_a = state.waypointActions) !== null && _a !== void 0 ? _a : {}, {
            $unset: [id],
        });
    },
    'waypoint/RESET_ITINERARIES': (state) => {
        state.itineraries = {};
    },
    'waypoint/RESET_NURSE_ITINERARIES': (state) => {
        state.nurseItineraries = [];
    },
    'waypoint/RESET_WAYPOINTS': (state) => {
        state.waypoints = {};
    },
    'waypoint/RESET_WAYPOINT_ACTIONS': (state) => {
        state.waypointActions = {};
    },
    'waypoint/SET_DRAFT_WAYPOINT': (state, newItem) => {
        var _a;
        state.draftWaypoints = update((_a = state.draftWaypoints) !== null && _a !== void 0 ? _a : {}, {
            [newItem.id]: { $set: newItem },
        });
    },
    'waypoint/SET_DRAFT_WAYPOINTS': (state, draftWaypoints) => {
        state.draftWaypoints = {
            ...state.draftWaypoints,
            ...draftWaypoints,
        };
    },
    'waypoint/SET_ITINERARIES': (state, itineraries) => {
        state.itineraries = {
            ...state.itineraries,
            ...itineraries,
        };
    },
    'waypoint/SET_ITINERARY': (state, newItem) => {
        var _a;
        state.itineraries = update((_a = state.itineraries) !== null && _a !== void 0 ? _a : {}, {
            [newItem.id]: { $set: newItem },
        });
    },
    'waypoint/SET_NURSE_ITINERARIES': (state, newItineraries) => {
        state.nurseItineraries = newItineraries;
    },
    'waypoint/SET_PROCESSING_ACTION_STATUS': (state, { processingActionID, status }) => {
        const currentProcessingAction = state.sampleProcessingActions[processingActionID];
        if (isNullish(currentProcessingAction))
            return;
        const newStatus = {
            status,
            timestamp: currentProcessingAction.status.timestamp,
        };
        state.sampleProcessingActions[processingActionID] = {
            ...currentProcessingAction,
            status: newStatus,
        };
    },
    'waypoint/SET_SAMPLE_PROCESSING_ACTIONS': (state, sampleProcessingActions) => {
        var _a;
        state.sampleProcessingActions = update((_a = state.sampleProcessingActions) !== null && _a !== void 0 ? _a : {}, {
            $merge: sampleProcessingActions,
        });
    },
    'waypoint/SET_WAYPOINT': (state, newItem) => {
        var _a;
        state.waypoints = update((_a = state.waypoints) !== null && _a !== void 0 ? _a : {}, {
            [newItem.id]: { $set: newItem },
        });
    },
    'waypoint/SET_WAYPOINTS': (state, newItems) => {
        state.waypoints = {
            ...state.waypoints,
            ...newItems,
        };
    },
    'waypoint/SET_WAYPOINT_ACTION': (state, newItem) => {
        var _a;
        state.waypointActions = update((_a = state.waypointActions) !== null && _a !== void 0 ? _a : {}, {
            [newItem.id]: { $set: newItem },
        });
    },
    'waypoint/SET_WAYPOINT_ACTIONS': (state, newWaypointActions) => {
        state.waypointActions = {
            ...state.waypointActions,
            ...newWaypointActions,
        };
    },
    'waypoint/SET_WAYPOINT_ACTION_STATUS': (state, { waypointActionID, status, }) => {
        const currentWaypointAction = state.waypointActions[waypointActionID];
        if (isNullish(currentWaypointAction))
            return;
        const newStatus = {
            status,
            timestamp: Date.now(),
        };
        state.waypointActions[waypointActionID] = {
            ...currentWaypointAction,
            status: newStatus,
        };
    },
    'waypoint/SET_WAYPOINT_DELAY_INFO': (state, { waypointID, delayInfo, }) => {
        var _a, _b, _c;
        state.waypoints = update((_a = state.waypoints) !== null && _a !== void 0 ? _a : {}, {
            [waypointID]: {
                transitInfo: { $set: update((_c = (_b = state.waypoints[waypointID]) === null || _b === void 0 ? void 0 : _b.transitInfo) !== null && _c !== void 0 ? _c : {}, {
                        delayInfo: { $set: delayInfo },
                    }) },
            },
        });
    },
};
/**
 * Non-standard naming to avoid conflict with references to values of type
 * `WaypointAction`
 */
const waypointModuleActions = {
    'waypoint/fetchDraftWaypointData': async function ({ commit, dispatch, getters, rootGetters }, draftWaypointID) {
        var _a, _b, _c;
        const writers = (_a = rootGetters['app/getDefaultFetchWithRelationshipsCallbacks']) === null || _a === void 0 ? void 0 : _a.call(rootGetters, commit, dispatch);
        const response = await fetchWithRelationships(DbRef.DRAFT_WAYPOINTS, draftWaypointID, getters['waypoint/getDraftWaypointDepsRelationships'], { writers });
        try {
            if ((_c = (_b = response.draftWaypoints) === null || _b === void 0 ? void 0 : _b[draftWaypointID]) === null || _c === void 0 ? void 0 : _c.draftOrderID) {
                const draftWaypointData = await getDraftWaypointDataRequest({ draftWaypointID,
                    request: {
                        includeBookingDataInProcedureData: true,
                        includeContactDataInProcedureData: true,
                        includeItineraryDataInDraftWaypointData: true,
                        includeNurseDataInProcedureData: true,
                        includeOrderDataInBookingData: true,
                        includePatientDataInBookingData: true,
                        includePlaceAccountsDataInProcedureData: true,
                        includePlaceDataInWaypointData: true,
                        includePlaceGroupDataInWaypointData: true,
                        includePlaceGroupsDataInProcedureData: true,
                        includePrescriberDataInOrderData: true,
                        includeProceduresDataInDraftWaypointData: true,
                        includeSchedulingUserDataInOrderData: true,
                        includeSupplyTransfersDataInDraftWaypointData: true,
                        includeWaypointActionsDataInWaypointData: true,
                        includeWaypointDataInDraftWaypointData: true,
                        includeWaypointsDataInItineraryData: true,
                    } });
                if (isNullish(draftWaypointData))
                    throw Error(`Unable to load data for draftWaypoint ${draftWaypointID}.`);
                setDraftWaypointDataInStore(commit, [draftWaypointData], this);
            }
        }
        catch (error) {
            toastErrorAndReport(`There was a problem loading your waypoint data. ${errorSuffix}`);
        }
    },
    async 'waypoint/fetchItineraryData'({ commit, dispatch }, itineraryID) {
        const response = await fetchWithRelationships(DbRef.ITINERARIES, itineraryID, {
            nurseID: true,
            waypoints: {
                placeID: true,
                /**
                 * Relationship dependencies in processing actions will never
                 * vary between those in waypoint actions in the same itinerary
                 */
                processingActions: true,
                waypointActions: {
                    procedures: {
                        bookingID: {
                            orderID: {
                                prescriberID: true,
                            },
                            patientID: true,
                        },
                    },
                    shipments: true,
                },
            },
        });
        const { [DbRef.BOOKINGS]: bookings, [DbRef.ITINERARIES]: itineraries, [DbRef.ORDERS]: orders, [DbRef.PLACES]: places, [DbRef.PLACE_GROUPS]: placeGroups, [DbRef.PROCEDURES]: procedures, [DbRef.SHIPMENTS]: shipments, [DbRef.USERS]: users, [DbRef.WAYPOINTS]: waypoints, [DbRef.WAYPOINT_ACTIONS]: allWaypointActions, } = response;
        const waypointActions = objectFilter(allWaypointActions !== null && allWaypointActions !== void 0 ? allWaypointActions : {}, (wpa) => wpa.type !== WaypointActionType.SAMPLE);
        const sampleProcessingActions = objectFilter(allWaypointActions !== null && allWaypointActions !== void 0 ? allWaypointActions : {}, (wpa) => wpa.type === WaypointActionType.SAMPLE);
        if (itineraries)
            commit('waypoint/SET_ITINERARIES', itineraries);
        if (waypointActions)
            commit('waypoint/SET_WAYPOINT_ACTIONS', waypointActions);
        if (waypoints)
            commit('waypoint/SET_WAYPOINTS', waypoints);
        if (sampleProcessingActions)
            commit('waypoint/SET_SAMPLE_PROCESSING_ACTIONS', sampleProcessingActions);
        if (places) {
            if (hasMutation(this, 'places/SET_PLACES')) {
                customCommit(commit, 'places/SET_PLACES', places);
            }
        }
        if (placeGroups) {
            if (hasMutation(this, 'places/SET_PLACE_GROUPS')) {
                customCommit(commit, 'places/SET_PLACE_GROUPS', placeGroups);
            }
        }
        if (orders) {
            if (hasMutation(this, 'orders/SET_ORDERS')) {
                customCommit(commit, 'orders/SET_ORDERS', orders);
            }
        }
        if (bookings) {
            if (hasMutation(this, 'bookings/SET_BOOKINGS')) {
                customCommit(commit, 'bookings/SET_BOOKINGS', bookings);
            }
        }
        if (shipments) {
            if (hasMutation(this, 'supplies/SET_SHIPMENTS')) {
                customCommit(commit, 'supplies/SET_SHIPMENTS', shipments);
            }
        }
        if (users) {
            if (hasMutation(this, 'users/SET_USERS')) {
                customCommit(commit, 'users/SET_USERS', Object.values(users));
            }
        }
        if (procedures) {
            /**
             * Custom override for procedures to fetch contact user data
             *
             * TODO: Support nested key relationships for relationship collection
             */
            const contactUserIDs = Object.values(procedures)
                .map((p) => { var _a; return (_a = p.contact) === null || _a === void 0 ? void 0 : _a.userID; })
                .filter(nullishFilter);
            if (contactUserIDs.length > 0) {
                dispatch('users/fetchUsers', contactUserIDs);
            }
            if (hasMutation(this, 'procedures/SET_PROCEDURES')) {
                customCommit(commit, 'procedures/SET_PROCEDURES', procedures);
            }
        }
    },
    'waypoint/fetchWaypointData': async function ({ commit, dispatch, rootGetters }, waypointID) {
        var _a;
        try {
            const orderRelationships = {
                officeID: true,
                prescriberID: true,
            };
            const bookingsRelationships = {
                orderID: orderRelationships,
                patientID: true,
            };
            const proceduresRelationships = {
                bookingID: bookingsRelationships,
                placeAccounts: true,
            };
            const waypointActionsRelationships = {
                procedures: proceduresRelationships,
                shipments: true,
            };
            const placeRelationships = {
                placeGroupID: true,
            };
            const writers = (_a = rootGetters['app/getDefaultFetchWithRelationshipsCallbacks']) === null || _a === void 0 ? void 0 : _a.call(rootGetters, commit, dispatch);
            await fetchWithRelationships(DbRef.WAYPOINTS, waypointID, {
                itineraryID: true,
                placeID: placeRelationships,
                processingActions: true,
                waypointActions: waypointActionsRelationships,
            }, { writers });
        }
        catch (error) {
            toastErrorAndReport(`There was a problem loading your waypoint data. ${errorSuffix}`);
        }
    },
    'waypoint/maybeCancelWaypointActions': async ({ dispatch, state, rootState }, { waypointActionIDs }) => {
        const actionStatusUpdatesPromises = waypointActionIDs.map(async (waypointActionID) => {
            var _a, _b, _c, _d;
            const action = (_a = state.waypointActions[waypointActionID]) !== null && _a !== void 0 ? _a : state.sampleProcessingActions[waypointActionID];
            if (!action || !action.waypointID)
                return;
            const procedureIDs = Object.keys((_b = action.procedures) !== null && _b !== void 0 ? _b : {});
            const allProceduresCanceled = !procedureIDs.some((procedureID) => {
                const procedure = rootState.procedures.procedures[procedureID];
                if (!procedure)
                    return false;
                return !hasStatus(procedure, ProcedureStatus.CANCELED);
            });
            const officeType = (_d = (_c = rootState.office) === null || _c === void 0 ? void 0 : _c.office) === null || _d === void 0 ? void 0 : _d.type;
            if (allProceduresCanceled) {
                if (action.type === WaypointActionType.SAMPLE) {
                    await dispatch('waypoint/setProcessingActionStatus', {
                        processingActionID: waypointActionID,
                        status: WaypointActionStatusName.CANCELED,
                    });
                }
                else {
                    await dispatch('waypoint/setWaypointActionStatus', {
                        officeType,
                        status: WaypointActionStatusName.CANCELED,
                        waypointActionID,
                    });
                }
                await dispatch('waypoint/maybeCompleteWaypoint', {
                    waypointID: action.waypointID,
                });
            }
        });
        await Promise.all(actionStatusUpdatesPromises);
    },
    'waypoint/maybeCompleteWaypoint': async ({ dispatch, state }, { waypointID }) => {
        var _a, _b, _c;
        try {
            const waypoint = state.waypoints[waypointID];
            if (!waypoint) {
                throw Error(`There was an error changing the Waypoint status.
          The Waypoint ${waypointID} is undefined.`);
            }
            const waypointActionIDs = (_b = (_a = waypoint.waypointActions) === null || _a === void 0 ? void 0 : _a.map(({ id }) => id)) !== null && _b !== void 0 ? _b : [];
            const processingActionIDs = Object.keys((_c = waypoint.processingActions) !== null && _c !== void 0 ? _c : {});
            const actionIDs = [...waypointActionIDs, ...processingActionIDs];
            const allActionsCanceledOrComplete = actionIDs.every((actionID) => {
                var _a;
                const action = (_a = state.waypointActions[actionID]) !== null && _a !== void 0 ? _a : state.sampleProcessingActions[actionID];
                if (!action)
                    return false;
                return hasStatus(action, [
                    WaypointActionStatusName.CANCELED,
                    WaypointActionStatusName.COMPLETE,
                ]);
            });
            if (allActionsCanceledOrComplete) {
                await dispatch('waypoint/updateWaypointAndActionStatus', {
                    waypointID,
                    waypointStatus: WaypointStatusName.COMPLETE,
                });
            }
        }
        catch (error) {
            toastErrorAndReport(error);
        }
    },
    'waypoint/saveItineraryFeedback': async (_store, feedback) => {
        try {
            if (!feedback)
                throw new Error('undefined Feedback');
            const validFeedback = getValidatedFeedback(feedback, true);
            const path = `${DbRef.FEEDBACK}/${validFeedback.id}`;
            await dbSet(path, removeUndefinedValuesFromObj(validFeedback));
            toastSuccess('Feedback submitted successfully!');
            return true;
        }
        catch (error) {
            toastErrorAndReport(error);
            return false;
        }
    },
    /**
     * @deprecated:
     * Replaced by portalStore.waypointActions.setChildOf(waypointActionID, 'mailInBoxBarcode', barcode, true)
     */
    'waypoint/saveMailInBoxBarcode': async ({ commit, state }, { mailInActionID, barcode, }) => {
        try {
            const mailInAction = state.waypointActions[mailInActionID];
            if (!mailInAction)
                throw Error('Mail-in action not found');
            const wpaPath = `${DbRef.WAYPOINT_ACTIONS}/${mailInActionID}/mailInBoxBarcode`;
            await dbSet(wpaPath, barcode);
            commit('waypoint/SET_WAYPOINT_ACTION', {
                ...mailInAction,
                mailInBoxBarcode: barcode,
            });
        }
        catch (error) {
            toastErrorAndReport(`Unable to update barcode: ${error}`);
        }
    },
    /**
     * @deprecated:
     * Only used in once place
     * Replaced by portalStore.waypoints.setChildOf(waypointID, 'transitInfo/delayInfo', delayInfo, true)
     */
    'waypoint/saveWaypointArrivalDelayInfo': async ({ commit, rootGetters, rootState, state }, { waypointID, delayReason, }) => {
        var _a, _b, _c;
        try {
            const itineraryID = (_a = state.waypoints[waypointID]) === null || _a === void 0 ? void 0 : _a.itineraryID;
            if (!itineraryID)
                return;
            const leaveFrom = (_c = (_b = rootState.auth.user) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.current;
            const drivingEstimate = await getItineraryDrivingEstimateRequest({
                itineraryID,
                leaveFrom,
                waypointID,
            });
            if (!drivingEstimate)
                throw new Error('Unable to calculate driving estimate');
            const delayInfo = {
                newDrivingEstimate: drivingEstimate / 1000,
                reason: delayReason,
                timeZone: rootGetters['auth/getUserTimeZone'],
                timestamp: Date.now(),
            };
            const path = `${DbRef.WAYPOINTS}/${waypointID}/transitInfo/delayInfo`;
            dbUpdate(path, delayInfo);
            commit('waypoint/SET_WAYPOINT_DELAY_INFO', {
                delayInfo,
                waypointID,
            });
        }
        catch (error) {
            toastErrorAndReport(error);
        }
    },
    'waypoint/setAllProcessingActionStatuses': async (context, { waypointID, status, }) => {
        var _a;
        const { state } = context;
        const waypoint = state.waypoints[waypointID];
        if (!waypoint)
            return;
        const processingActionIDs = Object.keys((_a = waypoint.processingActions) !== null && _a !== void 0 ? _a : {});
        const promises = processingActionIDs.map((processingActionID) => context.dispatch('waypoint/setProcessingActionStatus', {
            processingActionID,
            status,
        }));
        await Promise.all(promises);
    },
    'waypoint/setDraftWaypointsStatus': async ({ commit, state }, params) => {
        const updates = {};
        Object.values(params).forEach((param) => {
            updates[`${DbRef.DRAFT_WAYPOINTS}/${param.id}/status`] = param.status;
            if (param.rejectionReason) {
                updates[`${DbRef.DRAFT_WAYPOINTS}/${param.id}/rejectionReason`] = param.rejectionReason;
            }
            if (param.finalizedDate) {
                updates[`${DbRef.DRAFT_WAYPOINTS}/${param.id}/finalizedDate`] = param.finalizedDate;
            }
        });
        try {
            await dbGroupSet(updates);
            const arrayDraftWaypoints = Object.values(params).map((param) => {
                if (!param.id)
                    return;
                const draftWaypoint = state.draftWaypoints[param.id];
                if (!draftWaypoint)
                    return;
                return {
                    ...draftWaypoint,
                    ...param,
                };
            }).filter(nullishFilter);
            commit('waypoint/SET_DRAFT_WAYPOINTS', arrayToObj(arrayDraftWaypoints, 'id'));
        }
        catch (error) {
            toastError(error);
        }
    },
    'waypoint/setProceduresSamplesStatus': async function ({ commit, state, rootState }, params) {
        const { status } = params;
        const updates = {};
        const waypoint = state.waypoints[params.waypointID];
        if (!waypoint)
            return;
        const { waypointActions } = waypoint;
        if (isNullish(waypointActions)) {
            throw Error(`There was an error changing the procedures supply status.
      The waypoint or waypoint actions are undefined.`);
        }
        /** Filter waypoint actions for all waypoint actions aren't canceled */
        const waypointActionIDs = waypointActions
            .map(({ id }) => state.waypointActions[id])
            .filter(nullishFilter)
            .filter(({ status: waypointActionStatus }) => !hasStatus(waypointActionStatus, WaypointActionStatusName.CANCELED));
        /** Get all procedures on waypoint */
        const procedures = flattenArray(waypointActionIDs.map(({ id }) => {
            var _a;
            const waypointAction = state.waypointActions[id];
            if (!waypointAction)
                return [];
            return Object.keys((_a = waypointAction.procedures) !== null && _a !== void 0 ? _a : {});
        })).map((id) => rootState.procedures.procedures[id])
            .filter(nullishFilter);
        /** Iterate through procedures and set sample status to target */
        procedures.forEach((inputProcedure) => {
            const procedure = inputProcedure;
            if (!procedure)
                return;
            const procedureSamples = procedure.samples;
            if (!procedureSamples)
                return;
            Object.values(procedureSamples).forEach((sample) => {
                if (!sample)
                    return;
                const sampleID = sample.id;
                procedure.samples = {
                    ...procedureSamples,
                    [sampleID]: {
                        ...sample,
                        status,
                    },
                };
                updates[`${DbRef.PROCEDURES}/${procedure.id}/samples/${sampleID}/status`] = status;
                if (status === SampleStatus.COMPLETED) {
                    updates[`${DbRef.PROCEDURES}/${procedure.id}/samples/${sampleID}/dropOffTimestamp`] = Date.now();
                }
            });
            if (hasMutation(this, 'procedures/SET_PROCEDURE')) {
                customCommit(commit, 'procedures/SET_PROCEDURE', procedure);
            }
        });
        try {
            await dbGroupSet(updates);
        }
        catch (error) {
            toastErrorAndReport(error);
        }
    },
    'waypoint/setProcessingActionStatus': async ({ commit, dispatch, rootState, state }, { processingActionID, status, }) => {
        var _a;
        try {
            const processingAction = state.sampleProcessingActions[processingActionID];
            if (!processingAction) {
                throw Error(`There was an error changing the Processing Action status.
          The Processing Action ${processingActionID} is undefined.`);
            }
            const officeType = (_a = rootState.office.office) === null || _a === void 0 ? void 0 : _a.type;
            await setWaypointActionStatusRequest({
                officeType,
                status,
                waypointActionID: processingActionID,
            });
            commit('waypoint/SET_PROCESSING_ACTION_STATUS', {
                processingActionID,
                status,
            });
            const isCanceledOrComplete = hasStatus(processingAction, [
                WaypointActionStatusName.CANCELED,
                WaypointActionStatusName.COMPLETE,
            ]);
            if (isCanceledOrComplete && processingAction.waypointID) {
                await dispatch('waypoint/maybeCompleteWaypoint', {
                    waypointID: processingAction.waypointID,
                });
            }
        }
        catch (error) {
            toastErrorAndReport(error);
        }
    },
    /**
     * TODO: I WANT TO DEPRECATE THIS JAWN @pumposh
     */
    'waypoint/setWaypointActionStatus': async function ({ commit, dispatch, state, rootState }, params) {
        var _a, _b;
        const { waypointActionID, status, updateProcedureStatus, } = params;
        const waypointAction = (_a = state.waypointActions[waypointActionID]) !== null && _a !== void 0 ? _a : state.sampleProcessingActions[waypointActionID];
        try {
            if (!waypointAction) {
                throw Error(`There was an error changing the Waypoint Action status.
          The Waypoint Action ${waypointActionID} is undefined.`);
            }
            const procedureCanceled = await setWaypointActionStatusRequest(params);
            commit('waypoint/SET_WAYPOINT_ACTION', {
                ...waypointAction,
                status: {
                    status,
                    timestamp: Date.now(),
                },
            });
            if (updateProcedureStatus) {
                Object.keys((_b = waypointAction.procedures) !== null && _b !== void 0 ? _b : {}).forEach((procedureID) => {
                    const procedure = rootState.procedures.procedures[procedureID];
                    if (procedure) {
                        if (hasMutation(this, 'procedures/SET_PROCEDURE')) {
                            customCommit(commit, 'procedures/SET_PROCEDURE', {
                                ...procedure,
                                procedureCanceled,
                                status: updateProcedureStatus,
                            });
                        }
                    }
                });
            }
            const isCanceledOrComplete = hasStatus(waypointAction, [
                WaypointActionStatusName.CANCELED,
                WaypointActionStatusName.COMPLETE,
            ]);
            if (isCanceledOrComplete && waypointAction.waypointID) {
                await dispatch('waypoint/maybeCompleteWaypoint', {
                    waypointID: waypointAction.waypointID,
                });
            }
        }
        catch (error) {
            toastErrorAndReport(error);
        }
    },
    /**
     * @deprecated:
     * Replaced by portalStore.waypoints.setChildOf(waypointID, 'status', status, true)
     * and portalStore.waypointActions.setChildOf(waypointActionID, 'status', status, true)
     * NOTE: Determine if ordered waypoint status logic is still needed
     */
    'waypoint/updateWaypointAndActionStatus': async ({ commit, state }, { waypointID, waypointStatus, waypointActionStatus, }) => {
        var _a, _b;
        const waypoint = (_a = state.waypoints) === null || _a === void 0 ? void 0 : _a[waypointID];
        if (!waypoint) {
            throw Error(`There was an error changing the waypoint and waypoint action
      status because waypoint ${waypointID} is undefined`);
        }
        /** Update waypoint status */
        const waypointStatusUpdate = {
            status: waypointStatus,
            timestamp: Date.now(),
        };
        const updates = {};
        /** Compare order indices of current waypoint status and target waypoint status */
        const currentWaypointStatus = waypoint.status;
        const currentWaypointOrderIndex = WaypointStatusFulfillmentOrder[currentWaypointStatus.status];
        const targetWaypointOrderIndex = WaypointStatusFulfillmentOrder[waypointStatus];
        if (targetWaypointOrderIndex > currentWaypointOrderIndex) {
            updates[`${DbRef.WAYPOINTS}/${waypointID}/status`] = waypointStatusUpdate;
            commit('waypoint/SET_WAYPOINT', {
                ...waypoint,
                status: waypointStatusUpdate,
            });
        }
        if (waypointActionStatus) {
            Object.values((_b = waypoint.waypointActions) !== null && _b !== void 0 ? _b : {})
                .map((waypointObject) => waypointObject.id)
                .forEach((waypointActionID) => {
                /** Update waypoint action status */
                const wpaStatusPath = `${DbRef.WAYPOINT_ACTIONS}/${waypointActionID}/status`;
                updates[wpaStatusPath] = {
                    status: waypointActionStatus,
                    timestamp: Date.now(),
                };
                commit('waypoint/SET_WAYPOINT_ACTION_STATUS', {
                    status: waypointActionStatus,
                    waypointActionID,
                });
            });
        }
        await dbGroupSet(updates);
    },
};
const waypointGetters = {
    'waypoint/atLeastOneSampleOnProcedureRequiresProcessing': (state, _getters, rootState) => (procedureID, waypointID) => {
        var _a;
        const procedure = rootState.procedures.procedures[procedureID];
        if (!procedure || !procedure.samples)
            return false;
        const waypoint = waypointGetters['waypoint/getWaypointByID'](state)(waypointID);
        if (!waypoint)
            return false;
        const sampleProcessingActionIDs = Object.keys((_a = waypoint.processingActions) !== null && _a !== void 0 ? _a : {});
        const sampleProcessingActions = sampleProcessingActionIDs.map((id) => state.sampleProcessingActions[id]).filter(nullishFilter);
        return sampleProcessingActions.some((action) => {
            var _a;
            return Object.keys((_a = action.procedures) !== null && _a !== void 0 ? _a : {}).some((id) => id === procedureID);
        });
    },
    'waypoint/getAllSuppliesOnItinerary': (state, getters, rootState, rootGetters) => (itineraryID) => {
        const procedures = waypointGetters['waypoint/getProceduresOnItinerary'](state, getters, rootState)(itineraryID);
        const supplies = flattenArray(procedures.map((procedure) => {
            var _a, _b;
            const supplyInstructions = Object.values((_b = (_a = procedure.supplyInstructionConfig) === null || _a === void 0 ? void 0 : _a.supplyInstructions) !== null && _b !== void 0 ? _b : {});
            const patient = rootGetters['procedures/getPatientOnProcedure'](procedure.id);
            if (!patient)
                return [];
            const suppliesForProcedure = supplyInstructions.map((supplyInstruction) => {
                var _a;
                const { supplyID } = supplyInstruction;
                const supply = (_a = rootState.variables.variables) === null || _a === void 0 ? void 0 : _a.supplies[supplyID];
                if (!supply)
                    return null;
                return { ...supply, patient };
            }).filter(nullishFilter);
            return suppliesForProcedure;
        }));
        return supplies;
    },
    'waypoint/getDraftWaypointByID': (state) => (draftWaypointID) => {
        if (!draftWaypointID)
            return;
        const draftWaypoint = state.draftWaypoints[draftWaypointID];
        if (!draftWaypoint)
            return;
        return draftWaypoint;
    },
    'waypoint/getDraftWaypointDepsRelationships': (_state) => {
        const isPatientApp = isPatientUser();
        const bookingRelationships = {
            patientID: true,
        };
        const ordersRelationships = {
            bookings: bookingRelationships,
            prescriberID: true,
            schedulingUserID: true,
        };
        const supplyTransfersRelationships = {
            shipmentIDs: true,
        };
        const placesRelationships = {
            placeGroupID: true,
        };
        const placeGroupsRelationships = {
            places: true,
        };
        const baseProceduresRelationships = {
            bookingID: bookingRelationships,
            dropOffPlaceGroups: true,
            nurseID: true,
            orderID: ordersRelationships,
            placeAccounts: true,
            supplyItems: true,
            supplyTransferID: supplyTransfersRelationships,
        };
        const waypointActionsRelationships = {
            placeGroupID: placeGroupsRelationships,
            ...(isPatientApp ? undefined : { procedures: baseProceduresRelationships }),
            shipments: true,
        };
        const waypointsRelationships = {
            placeID: placesRelationships,
            waypointActions: waypointActionsRelationships,
        };
        const dwProceduresRelationships = {
            ...(isPatientApp ? undefined : baseProceduresRelationships),
            waypointActions: waypointActionsRelationships,
        };
        const itinerariesRelationships = {
            waypoints: waypointsRelationships,
        };
        const relationships = {
            itineraryID: itinerariesRelationships,
            ...(isPatientApp ? undefined : { procedures: dwProceduresRelationships }),
            supplyTransfers: supplyTransfersRelationships,
            waypointID: waypointsRelationships,
        };
        return isPatientApp ? {} : relationships;
    },
    /** For patient waypoint actions only */
    'waypoint/getIncompleteSampleProcessingActions': (state, getters, rootState) => (waypointID) => {
        var _a;
        try {
            const waypoint = waypointGetters['waypoint/getWaypointByID'](state)(waypointID);
            if (!waypoint)
                throw Error(`Waypoint ${waypointID} not found`);
            if (waypoint.type !== WaypointType.PATIENT)
                return [];
            const incompleteProcessingActions = Object.keys((_a = waypoint.processingActions) !== null && _a !== void 0 ? _a : {}).map((id) => {
                const pa = state.sampleProcessingActions[id];
                /** TODO: add a status for disabled processing actions */
                const isDisabled = !waypointGetters['waypoint/processingActionIsActive'](state, getters, rootState)(id);
                if (isDisabled)
                    return;
                const isDone = hasStatus(pa, [
                    WaypointActionStatusName.CANCELED,
                    WaypointActionStatusName.PACKED,
                    WaypointActionStatusName.COMPLETE,
                ]);
                if (!isDone)
                    return pa;
            }).filter(nullishFilter);
            return incompleteProcessingActions;
        }
        catch (error) {
            toastErrorAndReport(error);
            return [];
        }
    },
    'waypoint/getIsMailInBoxFromPatientWaypoint': (state) => (mailInActionID) => {
        const mailInAction = state.waypointActions[mailInActionID];
        if (!mailInAction)
            return false;
        const mailInWaypointID = mailInAction.waypointID;
        if (!mailInWaypointID)
            return false;
        const mailInWaypoint = state.waypoints[mailInWaypointID];
        if (!mailInWaypoint)
            return false;
        const { itineraryID } = mailInWaypoint;
        if (!itineraryID)
            return false;
        const itinerary = state.itineraries[itineraryID];
        if (!itinerary)
            return false;
        const waypointIndex = itinerary.waypoints.findIndex(({ id }) => id === mailInWaypointID);
        if (waypointIndex === -1)
            return false;
        const previousPatientWaypoints = itinerary.waypoints.slice(0, waypointIndex)
            .map(({ id }) => {
            var _a;
            return ((_a = state.waypoints[id]) === null || _a === void 0 ? void 0 : _a.type) === WaypointType.PATIENT
                ? state.waypoints[id]
                : undefined;
        }).filter(nullishFilter);
        return previousPatientWaypoints.some((patientWaypoint) => (patientWaypoint === null || patientWaypoint === void 0 ? void 0 : patientWaypoint.mailInWaypointActionID) === mailInActionID);
    },
    'waypoint/getIsPatientWaypointMailInBoxScanned': (state) => (waypointID) => {
        var _a;
        const mailInWaypointActionID = (_a = state.waypoints[waypointID]) === null || _a === void 0 ? void 0 : _a.mailInWaypointActionID;
        if (!mailInWaypointActionID)
            return false;
        const mailInWaypointAction = waypointGetters['waypoint/getMailInActionByID'](state)(mailInWaypointActionID);
        return !!(mailInWaypointAction === null || mailInWaypointAction === void 0 ? void 0 : mailInWaypointAction.mailInBoxBarcode);
    },
    /** This should be in the itinerary store module since an itineraryID is passed */
    'waypoint/getItineraryByID': (state) => (itineraryID) => itineraryID ? state.itineraries[itineraryID] : undefined,
    'waypoint/getItineraryMailInActions': (state) => (itineraryID) => {
        const waypointActions = waypointGetters['waypoint/getWaypointActionsOnItinerary'](state)(itineraryID);
        const mailInActions = waypointActions.map((waypointAction) => isMailInAction(waypointAction) ? waypointAction : undefined).filter(nullishFilter);
        return mailInActions;
    },
    'waypoint/getMailInActionByID': (state) => (waypointActionID) => {
        const waypointAction = state.waypointActions[waypointActionID];
        if (!waypointAction)
            return undefined;
        return isMailInAction(waypointAction)
            ? waypointAction
            : undefined;
    },
    'waypoint/getNurseByWaypointID': (state, _getters, rootState) => (waypointID) => {
        const waypoint = state.waypoints[waypointID];
        if (!(waypoint === null || waypoint === void 0 ? void 0 : waypoint.itineraryID))
            return undefined;
        const itinerary = state.itineraries[waypoint.itineraryID];
        if (!(itinerary === null || itinerary === void 0 ? void 0 : itinerary.nurseID))
            return;
        /** Should nurses be in rootState.users.staffUsers? */
        const nurse = rootState.users.users[itinerary.nurseID];
        return nurse;
    },
    'waypoint/getNurseItinerariesByDate': (state) => (date, nurseID) => {
        if (!nurseID)
            return [];
        return Object.values(state.nurseItineraries)
            .filter((itinerary) => {
            var _a, _b, _c;
            const startTime = (_a = itinerary === null || itinerary === void 0 ? void 0 : itinerary.startTime) !== null && _a !== void 0 ? _a : (_c = (_b = itinerary === null || itinerary === void 0 ? void 0 : itinerary.nursesOffered) === null || _b === void 0 ? void 0 : _b[nurseID !== null && nurseID !== void 0 ? nurseID : '']) === null || _c === void 0 ? void 0 : _c.startTime;
            return timeZoneDateMatchesLocalDate(startTime, date);
        })
            .map((itinerary) => {
            var _a, _b, _c;
            return ({
                ...itinerary,
                startTime: (_a = itinerary === null || itinerary === void 0 ? void 0 : itinerary.startTime) !== null && _a !== void 0 ? _a : (_c = (_b = itinerary === null || itinerary === void 0 ? void 0 : itinerary.nursesOffered) === null || _b === void 0 ? void 0 : _b[nurseID]) === null || _c === void 0 ? void 0 : _c.startTime,
            });
        });
    },
    'waypoint/getPlaceIDsOnItinerary': (state) => (itineraryID) => {
        var _a, _b;
        const waypoints = (_a = state.itineraries[itineraryID]) === null || _a === void 0 ? void 0 : _a.waypoints;
        const placeIDs = (_b = waypoints === null || waypoints === void 0 ? void 0 : waypoints.map(({ id: waypointID }) => {
            const waypoint = state.waypoints[waypointID];
            return waypoint === null || waypoint === void 0 ? void 0 : waypoint.placeID;
        }).filter(nullishFilter)) !== null && _b !== void 0 ? _b : [];
        return placeIDs;
    },
    'waypoint/getPlacesOnItinerary': (state, _getters, rootState) => (itineraryID) => {
        const placeIDs = waypointGetters['waypoint/getPlaceIDsOnItinerary'](state)(itineraryID);
        const places = placeIDs
            .map((id) => { var _a; return (_a = rootState.places.places) === null || _a === void 0 ? void 0 : _a[id]; })
            .filter(nullishFilter);
        return places;
    },
    'waypoint/getProceduresOnItinerary': (state, _getters, rootState) => (itineraryID) => {
        const waypointActionsData = waypointGetters['waypoint/getWaypointActionsOnItinerary'](state)(itineraryID);
        const procedureIDs = deduplicateArray(flattenArray(waypointActionsData.map((waypointAction) => { var _a; return Object.keys((_a = waypointAction.procedures) !== null && _a !== void 0 ? _a : []); })));
        const procedures = procedureIDs
            .map((id) => { var _a; return (_a = rootState.procedures.procedures) === null || _a === void 0 ? void 0 : _a[id]; })
            .filter(nullishFilter);
        return procedures;
    },
    'waypoint/getProceduresOnWaypointAction': (state, _getters, rootState) => (waypointActionID, isSampleProcessingAction = false) => {
        var _a, _b, _c;
        const waypointAction = isSampleProcessingAction
            ? (_a = state.sampleProcessingActions) === null || _a === void 0 ? void 0 : _a[waypointActionID]
            : (_b = state.waypointActions) === null || _b === void 0 ? void 0 : _b[waypointActionID];
        const procedures = Object.values((_c = waypointAction === null || waypointAction === void 0 ? void 0 : waypointAction.procedures) !== null && _c !== void 0 ? _c : {})
            .map(({ id }) => {
            var _a;
            const procedure = (_a = rootState.procedures.procedures) === null || _a === void 0 ? void 0 : _a[id];
            return !hasStatus(procedure, ProcedureStatus.CANCELED)
                ? procedure
                : undefined;
        }).filter(nullishFilter);
        return procedures;
    },
    'waypoint/getRouteToIncompleteMailInPackingOnWaypoint': (state, getters) => (waypointID) => {
        var _a, _b, _c;
        const waypoint = (_a = getters['waypoint/getWaypointByID']) === null || _a === void 0 ? void 0 : _a.call(getters, waypointID);
        if ((waypoint === null || waypoint === void 0 ? void 0 : waypoint.type) === WaypointType.PICK_DROP) {
            const mailInActionThatIsReadyToPack = (_c = (_b = getters['waypoint/mailInWaypointActionsThatAreReadyToPack']) === null || _b === void 0 ? void 0 : _b.call(getters, waypointID)) !== null && _c !== void 0 ? _c : {};
            const wpa = Object.values(mailInActionThatIsReadyToPack !== null && mailInActionThatIsReadyToPack !== void 0 ? mailInActionThatIsReadyToPack : {})[0];
            if (!wpa)
                return;
            return {};
        }
    },
    'waypoint/getRouteToNextCentrifugeActionOnWaypoint': (state, getters, rootState) => (waypointID) => {
        var _a;
        const waypoint = (_a = getters['waypoint/getWaypointByID']) === null || _a === void 0 ? void 0 : _a.call(getters, waypointID);
        if (hasStatus(waypoint, WaypointStatusName.COMPLETE))
            return;
        const incompleteSampleProcessingActions = waypointGetters['waypoint/getIncompleteSampleProcessingActions'](state, getters, rootState)(waypointID);
        const incompleteCentrifugeAction = incompleteSampleProcessingActions.filter((action) => action.supplyInstruction === SupplyInstructionOptions.CENTRIFUGE)[0];
        if (!incompleteCentrifugeAction)
            return;
        // return getSampleProcessingActionRoute(incompleteCentrifugeAction);
        return {};
    },
    'waypoint/getRouteToNextSampleProcessingActionOnWaypoint': (state, getters, rootState) => (waypointID) => {
        var _a;
        const waypoint = (_a = getters['waypoint/getWaypointByID']) === null || _a === void 0 ? void 0 : _a.call(getters, waypointID);
        if (!hasStatus(waypoint, WaypointStatusName.COMPLETE))
            return;
        const incompleteSampleProcessingAction = waypointGetters['waypoint/getIncompleteSampleProcessingActions'](state, getters, rootState)(waypointID)[0];
        if (!incompleteSampleProcessingAction)
            return;
        // return getSampleProcessingActionRoute(incompleteSampleProcessingAction);
        return {};
    },
    'waypoint/getRouteToReadyActionInItinerary': (state, getters, rootState) => (itineraryID) => {
        const itinerary = state.itineraries[itineraryID];
        if (!itinerary)
            return;
        const waypointIDs = itinerary.waypoints.map((idObj) => idObj.id);
        return waypointIDs.map((id) => waypointGetters['waypoint/getRouteToReadyActionInWaypoint'](state, getters, rootState)(id)).flat().filter(nullishFilter)[0];
    },
    'waypoint/getRouteToReadyActionInWaypoint': (state, getters, rootState) => (waypointID) => {
        const nextSampleActionRoute = waypointGetters['waypoint/getRouteToNextSampleProcessingActionOnWaypoint'](state, getters, rootState)(waypointID);
        if (nextSampleActionRoute)
            return nextSampleActionRoute;
        const incompleteMailInPacking = waypointGetters['waypoint/getRouteToIncompleteMailInPackingOnWaypoint'](state, getters)(waypointID);
        if (incompleteMailInPacking)
            return incompleteMailInPacking;
    },
    'waypoint/getSampleProcessingActionByID': (state) => (processingActionID) => {
        if (!processingActionID)
            return undefined;
        return state.sampleProcessingActions[processingActionID];
    },
    'waypoint/getSampleProcessingActionsOnItinerary': (state) => (itineraryID, throws = false) => {
        const waypoints = waypointGetters['waypoint/getWaypointsOnItinerary'](state)(itineraryID);
        const processingActionIDs = flattenArray(waypoints.map((waypoint) => { var _a; return Object.keys((_a = waypoint.processingActions) !== null && _a !== void 0 ? _a : {}); }));
        const processingActions = processingActionIDs.map((id) => {
            var _a;
            const processingAction = (_a = state.sampleProcessingActions) === null || _a === void 0 ? void 0 : _a[id];
            if (!processingAction && throws)
                throw Error(`Missing processingAction ${id}`);
            return processingAction;
        }).filter(nullishFilter);
        return processingActions;
    },
    'waypoint/getShiftIDByWaypointID': (state) => (waypointID) => {
        const waypoint = state.waypoints[waypointID];
        if (!(waypoint === null || waypoint === void 0 ? void 0 : waypoint.itineraryID))
            return undefined;
        const itinerary = state.itineraries[waypoint.itineraryID];
        return itinerary === null || itinerary === void 0 ? void 0 : itinerary.shiftID;
    },
    'waypoint/getStaffingOfficeByWaypointID': (state, _getters, rootState) => (waypointID) => {
        var _a, _b, _c;
        const waypoint = state.waypoints[waypointID];
        if (!(waypoint === null || waypoint === void 0 ? void 0 : waypoint.itineraryID))
            return undefined;
        const itinerary = state.itineraries[waypoint.itineraryID];
        if (!(itinerary === null || itinerary === void 0 ? void 0 : itinerary.shiftID))
            return undefined;
        const shift = (_a = rootState.shifts.shifts) === null || _a === void 0 ? void 0 : _a[itinerary.shiftID];
        if (!(shift === null || shift === void 0 ? void 0 : shift.staffingOffices))
            return undefined;
        // The active staffing office is the one with the latest timestamp
        const staffingOfficeID = (_b = getLatestInListTimestamp(shift.staffingOffices)) === null || _b === void 0 ? void 0 : _b.id;
        return staffingOfficeID ? (_c = rootState.offices.offices) === null || _c === void 0 ? void 0 : _c[staffingOfficeID] : undefined;
    },
    'waypoint/getUsersOnItinerary': (state, getters, rootState) => (itineraryID) => {
        var _a, _b;
        if (!itineraryID)
            return;
        const itinerary = (_a = state.itineraries) === null || _a === void 0 ? void 0 : _a[itineraryID];
        const assignedNurseID = itinerary === null || itinerary === void 0 ? void 0 : itinerary.nurseID;
        const offeredNurseIDs = Object.values((_b = itinerary === null || itinerary === void 0 ? void 0 : itinerary.nursesOffered) !== null && _b !== void 0 ? _b : {})
            .map((offer) => offer.nurseID);
        const nurseIDs = deduplicateArray([assignedNurseID, ...offeredNurseIDs]);
        const procedures = waypointGetters['waypoint/getProceduresOnItinerary'](state, getters, rootState)(itineraryID);
        const bookingIDs = deduplicateArray(procedures.map((procedure) => procedure.bookingID));
        const bookings = bookingIDs.map((id) => { var _a; return (_a = rootState.bookings.bookings) === null || _a === void 0 ? void 0 : _a[id]; })
            .filter(nullishFilter);
        const orderIDs = deduplicateArray(procedures.map((procedure) => procedure.orderID));
        const orders = orderIDs.map((id) => { var _a; return (_a = rootState.orders.orders) === null || _a === void 0 ? void 0 : _a[id]; })
            .filter(nullishFilter);
        const prescriberIDs = deduplicateArray(orders.map((order) => order.prescriberID)).filter(nullishFilter);
        const patientIDs = deduplicateArray(bookings.map((booking) => booking.patientID)).filter(nullishFilter);
        const userIDs = [
            ...nurseIDs,
            ...prescriberIDs,
            ...patientIDs,
        ].filter(nullishFilter);
        const users = userIDs.map((id) => rootState.users.users[id])
            .filter(nullishFilter);
        return users;
    },
    'waypoint/getWaypointActionByID': (state) => (waypointActionID) => {
        if (!waypointActionID)
            return undefined;
        return state.waypointActions[waypointActionID];
    },
    'waypoint/getWaypointActionsByWaypointID': (state) => (waypointID) => {
        var _a, _b;
        const waypoint = state.waypoints[waypointID];
        return (_b = (_a = waypoint === null || waypoint === void 0 ? void 0 : waypoint.waypointActions) === null || _a === void 0 ? void 0 : _a.map(({ id }) => waypointGetters['waypoint/getWaypointActionByID'](state)(id)).filter(nullishFilter)) !== null && _b !== void 0 ? _b : [];
    },
    'waypoint/getWaypointActionsOnItinerary': (state) => (itineraryID, throws = false) => {
        const waypoints = waypointGetters['waypoint/getWaypointsOnItinerary'](state)(itineraryID);
        const waypointActionIDs = flattenArray(waypoints.map((waypoint) => { var _a, _b; return (_b = (_a = waypoint.waypointActions) === null || _a === void 0 ? void 0 : _a.map((idObj) => idObj.id)) !== null && _b !== void 0 ? _b : []; }));
        const waypointActions = waypointActionIDs.map((id) => {
            var _a;
            const waypointAction = (_a = state.waypointActions) === null || _a === void 0 ? void 0 : _a[id];
            if (!waypointAction && throws)
                throw Error(`Missing waypointAction ${id}`);
            return waypointAction;
        }).filter(nullishFilter);
        return waypointActions;
    },
    'waypoint/getWaypointByID': (state) => (waypointID) => waypointID ? state.waypoints[waypointID] : undefined,
    'waypoint/getWaypointHasDelayInfo': (state) => (waypointID) => { var _a, _b; return !!((_b = (_a = state.waypoints[waypointID]) === null || _a === void 0 ? void 0 : _a.transitInfo) === null || _b === void 0 ? void 0 : _b.delayInfo); },
    'waypoint/getWaypointHasMailInBox': (state) => (waypointID) => { var _a; return !!((_a = state.waypoints[waypointID]) === null || _a === void 0 ? void 0 : _a.mailInWaypointActionID); },
    'waypoint/getWaypointMailInActions': (state) => (waypointID) => {
        const waypointActions = waypointGetters['waypoint/getWaypointActionsByWaypointID'](state)(waypointID);
        const mailInActions = waypointActions.map((waypointAction) => isMailInAction(waypointAction) ? waypointAction : undefined).filter(nullishFilter);
        return mailInActions;
    },
    'waypoint/getWaypointMailInShipments': (state, _getters, rootState) => (waypointID) => {
        const waypointActions = waypointGetters['waypoint/getWaypointActionsByWaypointID'](state)(waypointID);
        const shipmentIDs = waypointActions.reduce((ids, waypointAction) => {
            var _a;
            const isMailIn = waypointAction.type === WaypointActionType.MAIL_IN;
            if (!isMailIn)
                return ids;
            return [...ids, ...Object.keys((_a = waypointAction.shipments) !== null && _a !== void 0 ? _a : {})];
        }, []);
        const shipments = getElementsFromIDs(shipmentIDs, (id) => { var _a; return (_a = rootState.supplies.shipments) === null || _a === void 0 ? void 0 : _a[id]; }, 'shipment');
        return shipments;
    },
    /** For patient waypoint actions only */
    'waypoint/getWaypointNeedsCentrifuge': (state, getters, rootState) => (waypointID) => {
        const incompleteActions = waypointGetters['waypoint/getIncompleteSampleProcessingActions'](state, getters, rootState)(waypointID);
        return incompleteActions.some((action) => action.supplyInstruction === SupplyInstructionOptions.CENTRIFUGE);
    },
    'waypoint/getWaypointsOnItinerary': (state) => (itineraryID, throws = false) => {
        var _a, _b;
        const itinerary = (_a = state.itineraries) === null || _a === void 0 ? void 0 : _a[itineraryID];
        const waypointIDs = (_b = itinerary === null || itinerary === void 0 ? void 0 : itinerary.waypoints.map((idObj) => idObj.id)) !== null && _b !== void 0 ? _b : [];
        const waypoints = waypointIDs
            .map((id) => {
            var _a;
            const waypoint = (_a = state.waypoints) === null || _a === void 0 ? void 0 : _a[id];
            if (!waypoint && throws)
                throw Error(`Missing waypoint ${id}`);
            return waypoint;
        })
            .filter(nullishFilter);
        return waypoints;
    },
    'waypoint/isItineraryComplete': (state, _rootGetters) => (itineraryID) => {
        const itinerary = state.itineraries[itineraryID];
        if (!itinerary)
            return false;
        const waypointIDs = itinerary.waypoints.map((idObj) => idObj.id);
        const waypoints = waypointIDs.map((id) => state.waypoints[id]).filter(nullishFilter);
        const allWaypointsComplete = waypoints.every((waypoint) => waypointGetters['waypoint/isWaypointComplete'](state)(waypoint.id));
        const allWaypointActionsOnItinerary = waypointGetters['waypoint/getWaypointActionsOnItinerary'](state)(itineraryID);
        const allWaypointActionsAreCompleted = allWaypointActionsOnItinerary.every((waypointAction) => hasStatus(waypointAction.status, [
            WaypointActionStatusName.COMPLETE,
            WaypointActionStatusName.CANCELED,
        ]));
        return allWaypointsComplete
            && allWaypointActionsAreCompleted;
    },
    'waypoint/isSampleProcessingDisabled': (_state, _getters, rootState) => (procedureID) => { var _a, _b; return !!((_b = (_a = rootState.procedures.procedures) === null || _a === void 0 ? void 0 : _a[procedureID]) === null || _b === void 0 ? void 0 : _b.disableSampleProcessing); },
    'waypoint/isWaypointComplete': (state) => (waypointID) => { var _a; return hasStatus((_a = state.waypoints[waypointID !== null && waypointID !== void 0 ? waypointID : '']) === null || _a === void 0 ? void 0 : _a.status, WaypointStatusName.COMPLETE); },
    'waypoint/mailInActionsAreComplete': (state) => (waypointID) => {
        var _a, _b;
        const waypoint = waypointGetters['waypoint/getWaypointByID'](state)(waypointID);
        const waypointActionIDs = (_b = (_a = waypoint === null || waypoint === void 0 ? void 0 : waypoint.waypointActions) === null || _a === void 0 ? void 0 : _a.map((idObj) => idObj.id)) !== null && _b !== void 0 ? _b : [];
        const actions = waypointActionIDs.map((id) => state.waypointActions[id])
            .filter(nullishFilter);
        const actionsAreComplete = actions.every((action) => hasStatus(action.status, [
            WaypointActionStatusName.PACKED,
            WaypointActionStatusName.COMPLETE,
            WaypointActionStatusName.CANCELED,
        ]));
        return actionsAreComplete;
    },
    /** For PICK_DROP waypoint actions only */
    'waypoint/mailInWaypointActionsThatAreReadyToPack': (state) => (waypointID) => {
        var _a;
        try {
            const waypoint = waypointGetters['waypoint/getWaypointByID'](state)(waypointID);
            if (!waypoint)
                throw Error(`Waypoint ${waypointID} not found`);
            if (waypoint.type !== WaypointType.PICK_DROP)
                return {};
            const readyToPackMailInWaypointActions = Object.values((_a = waypoint.waypointActions) !== null && _a !== void 0 ? _a : [])
                .map((idObj) => state.waypointActions[idObj.id])
                .filter((wpa) => !!wpa
                && wpa.type === WaypointActionType.MAIL_IN
                && waypointGetters['waypoint/readyToPack'](state)(wpa.id)).filter(nullishFilter);
            return arrayToObj(readyToPackMailInWaypointActions, 'id');
        }
        catch (error) {
            toastErrorAndReport(error);
            return {};
        }
    },
    'waypoint/procedureRequiresCentrifugationOffline': (state, getters, rootState) => (procedureID, waypointID) => {
        const atLeastOneSampleOnProcedureRequiresProcessing = waypointGetters['waypoint/atLeastOneSampleOnProcedureRequiresProcessing'](state, getters, rootState)(procedureID, waypointID);
        const procedure = rootState.procedures.procedures[procedureID];
        return atLeastOneSampleOnProcedureRequiresProcessing && !!(procedure === null || procedure === void 0 ? void 0 : procedure.disableSampleProcessing);
    },
    'waypoint/proceduresExistInIncompletePatientWaypointActions': (state) => (waypointActionID) => {
        var _a, _b;
        const waypointAction = state.waypointActions[waypointActionID];
        const thisActionsProcedureIDs = Object.values((_a = waypointAction === null || waypointAction === void 0 ? void 0 : waypointAction.procedures) !== null && _a !== void 0 ? _a : {}).map((obj) => obj.id);
        const waypointActionsOnItinerary = waypointGetters['waypoint/getWaypointActionsOnItinerary'](state)((_b = waypointAction === null || waypointAction === void 0 ? void 0 : waypointAction.itineraryID) !== null && _b !== void 0 ? _b : '');
        const patientWaypointActions = waypointActionsOnItinerary.filter((wpa) => wpa.type === WaypointActionType.PATIENT_ACTION);
        const incompletePatientWaypointActions = patientWaypointActions.filter((wpa) => !hasStatus(wpa.status, WaypointActionStatusName.COMPLETE));
        const procedureIDsOnIncompleteWaypointActions = incompletePatientWaypointActions.map((wpa) => { var _a; return Object.values((_a = wpa.procedures) !== null && _a !== void 0 ? _a : {}); }).flat().map((obj) => obj.id);
        const matches = procedureIDsOnIncompleteWaypointActions.some((id) => thisActionsProcedureIDs.includes(id));
        return matches;
    },
    'waypoint/proceduresExistinIncompleteProcessingActions': (state) => (waypointActionID) => {
        var _a, _b, _c, _d;
        const waypointAction = state.waypointActions[waypointActionID];
        const procedureIDs = Object.values((_a = waypointAction === null || waypointAction === void 0 ? void 0 : waypointAction.procedures) !== null && _a !== void 0 ? _a : {}).map((obj) => obj.id);
        const waypoint = state.waypoints[(_b = waypointAction === null || waypointAction === void 0 ? void 0 : waypointAction.waypointID) !== null && _b !== void 0 ? _b : ''];
        if (!waypoint)
            throw Error(`Waypoint ${waypointAction === null || waypointAction === void 0 ? void 0 : waypointAction.waypointID} not found`);
        const itinerary = state.itineraries[(_c = waypoint.itineraryID) !== null && _c !== void 0 ? _c : ''];
        if (!itinerary)
            throw Error(`Itinerary ${waypoint.itineraryID} not found`);
        const waypointIDs = (_d = itinerary.waypoints) !== null && _d !== void 0 ? _d : [];
        const waypoints = waypointIDs.map((idObj) => state.waypoints[idObj.id]).filter(nullishFilter);
        const sampleProcessingActionIDs = waypoints.map((wp) => { var _a; return Object.keys((_a = wp.processingActions) !== null && _a !== void 0 ? _a : {}); }).flat();
        const sampleProcessingActions = sampleProcessingActionIDs.map((id) => state.sampleProcessingActions[id]).filter(nullishFilter);
        const someProcedureExistsInIncompleteProcessingActions = sampleProcessingActions.some((spa) => {
            const sampleProcessingActionIsIncomplete = !hasStatus(spa.status, WaypointActionStatusName.COMPLETE);
            const someProcedureExistsInSampleProcessingAction = procedureIDs.some((id) => { var _a; return Object.keys((_a = spa.procedures) !== null && _a !== void 0 ? _a : {}).includes(id); });
            return sampleProcessingActionIsIncomplete && someProcedureExistsInSampleProcessingAction;
        });
        return someProcedureExistsInIncompleteProcessingActions;
    },
    'waypoint/processingActionIsActive': (state, getters, rootState) => (actionID) => {
        var _a;
        const processingAction = state.sampleProcessingActions[actionID];
        if (!processingAction)
            return false;
        const procedures = (_a = processingAction.procedures) !== null && _a !== void 0 ? _a : {};
        const procedureIDs = Object.keys(procedures);
        const someProcedureSampleProcessingIsActive = procedureIDs.some((procedureID) => !waypointGetters['waypoint/isSampleProcessingDisabled'](state, getters, rootState)(procedureID));
        return someProcedureSampleProcessingIsActive;
    },
    'waypoint/processingActionsAreCompletedOrCanceled': (state) => (waypointID) => {
        var _a;
        const waypoint = waypointGetters['waypoint/getWaypointByID'](state)(waypointID);
        if (!waypoint)
            return false;
        const processingActions = Object.keys((_a = waypoint === null || waypoint === void 0 ? void 0 : waypoint.processingActions) !== null && _a !== void 0 ? _a : {});
        return processingActions.every((id) => {
            var _a;
            return hasStatus((_a = state.sampleProcessingActions) === null || _a === void 0 ? void 0 : _a[id], [
                WaypointActionStatusName.COMPLETE,
                WaypointActionStatusName.CANCELED,
            ]);
        });
    },
    'waypoint/processingActionsExist': (state) => (waypointID) => {
        var _a, _b;
        const waypoint = state.waypoints[waypointID];
        if (!waypoint)
            return false;
        const processingActionsExist = Object.keys((_a = waypoint.processingActions) !== null && _a !== void 0 ? _a : {}).length > 0;
        const waypointActionIDs = waypoint.waypointActions;
        const actionsOnWaypoint = waypointActionIDs === null || waypointActionIDs === void 0 ? void 0 : waypointActionIDs.map((idObj) => state.waypointActions[idObj.id]).filter(nullishFilter);
        const mailInWaypointActions = (_b = actionsOnWaypoint === null || actionsOnWaypoint === void 0 ? void 0 : actionsOnWaypoint.filter((wpa) => wpa.type === WaypointActionType.MAIL_IN)) !== null && _b !== void 0 ? _b : [];
        const mailInActionsExist = mailInWaypointActions.length > 0;
        return processingActionsExist || mailInActionsExist;
    },
    /**
     * only the previous waypoint needs to be checked
     */
    'waypoint/readyToPack': (state) => (waypointActionID) => {
        var _a, _b, _c;
        try {
            const waypointAction = state.waypointActions[waypointActionID];
            if (!waypointAction) {
                throw new Error(`Waypoint action ${waypointActionID} not found`);
            }
            if (waypointAction.type !== WaypointActionType.MAIL_IN) {
                return false;
            }
            const isDone = hasStatus(waypointAction, [
                WaypointActionStatusName.CANCELED,
                WaypointActionStatusName.COMPLETE,
                WaypointActionStatusName.PACKED,
            ]);
            if (isDone)
                return false;
            const { waypointID } = waypointAction;
            const itinerary = state.itineraries[(_a = waypointAction.itineraryID) !== null && _a !== void 0 ? _a : ''];
            if (!itinerary)
                return false;
            const waypointOrder = itinerary.waypoints || [];
            const currentIndex = waypointOrder.findIndex((wp) => wp.id === waypointID);
            if (currentIndex > 0) {
                const previousWaypointIdObj = waypointOrder[currentIndex - 1];
                const previousWaypoint = state.waypoints[(_b = previousWaypointIdObj === null || previousWaypointIdObj === void 0 ? void 0 : previousWaypointIdObj.id) !== null && _b !== void 0 ? _b : ''];
                const isIncomplete = !hasStatus(previousWaypoint, WaypointStatusName.COMPLETE);
                if (!previousWaypoint || isIncomplete)
                    return false;
                const previousProcessingActions = Object.keys((_c = previousWaypoint.processingActions) !== null && _c !== void 0 ? _c : {});
                const allProcessingActionsComplete = previousProcessingActions.every((id) => hasStatus(state.sampleProcessingActions[id], [
                    WaypointActionStatusName.COMPLETE,
                    WaypointActionStatusName.CANCELED,
                ]));
                return allProcessingActionsComplete;
            }
            return true;
        }
        catch (error) {
            console.error('Error in "waypoint/readyToPack" getter:', error);
            toastErrorAndReport(error);
            return false;
        }
    },
    'waypoint/someProcessingActionOnWaypointIsDisabled': (state, getters, rootState) => (waypointID) => {
        var _a, _b;
        const waypoint = (_a = state.waypoints) === null || _a === void 0 ? void 0 : _a[waypointID];
        if (!waypoint)
            return false;
        return Object.keys((_b = waypoint.processingActions) !== null && _b !== void 0 ? _b : {}).some((actionID) => {
            const processingActionIsActive = waypointGetters['waypoint/processingActionIsActive'](state, getters, rootState)(actionID);
            return !processingActionIsActive;
        });
    },
    'waypoint/waypointHasMailInWaypointActions': (state) => (waypointID) => {
        try {
            const waypoint = waypointGetters['waypoint/getWaypointByID'](state)(waypointID);
            if (!waypoint)
                throw Error(`Waypoint ${waypointID} not found`);
            const waypointActionIDs = waypoint.waypointActions;
            if (!(waypointActionIDs === null || waypointActionIDs === void 0 ? void 0 : waypointActionIDs.length)) {
                throw Error(`Waypoint ${waypointID} has no waypoint actions`);
            }
            const actionsOnWaypoint = waypointActionIDs.map((idObj) => state.waypointActions[idObj.id]).filter(nullishFilter);
            const mailInWaypointActions = actionsOnWaypoint.filter((wpa) => wpa.type === WaypointActionType.MAIL_IN);
            return mailInWaypointActions.length > 0;
        }
        catch (error) {
            toastErrorAndReport(error);
            return false;
        }
    },
};
const waypointModule = {
    actions: waypointModuleActions,
    getters: waypointGetters,
    mutations: waypointMutations,
    state: waypointState,
};
const initWaypointModule = (moduleExtensions) => initExtendedModule(waypointModule, moduleExtensions);

export { initWaypointModule, waypointModule };
